<div class="tile mb-4">
  <!-- <div class="page-header">
    <div class="row">
      <div class="col-lg-12">
        <h2 class="mb-3 line-head" id="buttons">{{batchName}}</h2>
      </div>
    </div>
  </div> -->
  <div class="row">
    <div class="col-lg-4">
      <!-- <p class="bs-component">
        <button class="btn btn-primary" type="button">Home</button>
      </p> -->

    </div>
    <div class="col-lg-8">

      <mat-form-field>
        <input matInput (keyup)="applyFilter($event.target.value)"
          placeholder="Search by Reference No,Applicant Full Name or Programme">
      </mat-form-field>

    </div>


    <div *ngIf="showLoadingIndicator" class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>

    <div class="col-md-12">



      <div>
        <table mat-table [dataSource]="dataSource" matSort>



          <ng-container matColumnDef="StudentNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Student No. </th>
            <td mat-cell *matCellDef="let row"> {{row.StudentNumber}} </td>
          </ng-container>


          <ng-container matColumnDef="ApplicatantFullName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Full Name </th>
            <td mat-cell *matCellDef="let row"> {{row.ApplicatantFullName}} </td>
          </ng-container>

          <ng-container matColumnDef="ProgrammeFullName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Programme </th>
            <td mat-cell *matCellDef="let row"> {{row.ProgrammeFullName}} </td>
          </ng-container>



          <ng-container matColumnDef="Campus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Campus </th>
            <td mat-cell *matCellDef="let row"> {{row.Campus}} </td>
          </ng-container>

          <ng-container matColumnDef="AdmittedBatch">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Batch </th>
            <td mat-cell *matCellDef="let row"> {{getBatchName(row.AdmittedBatch)}} </td>
          </ng-container>


          <ng-container matColumnDef="Hall">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Hall </th>
            <td mat-cell *matCellDef="let row"> {{row.Hall}} </td>
          </ng-container>





          <ng-container matColumnDef="Action">
            <th mat-header-cell *matHeaderCellDef>LETTER</th>
            <td mat-cell *matCellDef="let element" >



              <a *ngIf="ShowAdmissionPrintOut" mat-icon-button [routerLink]="[ '/account/login' ]" target="_blank">
                <mat-icon>print</mat-icon>
                <span>Print</span>
              </a>


            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;">
          </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 20, 40, 100]" showFirstLastButtons></mat-paginator>
      </div>
    </div>

  </div>




</div>
